"use client"
import BenefitsSection from "../benefits-section";
import ArticlesSection from "../sections/articles";
import FindServicesContentNew from "../services/FindServicesContentNew";
import { PageData } from "./DynamicPageContent";

const Dynamic2 = ({ pageData, dict, lang }: { pageData: PageData, dict: any, lang: string }) => {
    
   return <>
         <FindServicesContentNew  dynamic2={true} dict={dict} currentLang={lang} title={pageData.title} />
         <BenefitsSection pageData={pageData} />
         <ArticlesSection />
      </>
    
  }

export default Dynamic2;